import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [ent, setEnt] = useState(null); // entitlements payload

  const loadEnt = useCallback(async () => {
    try {
      const { data } = await api.get("/me/entitlements");
      setEnt(data);
    } catch {
      setEnt(null);
    }
  }, []);

  const load = useCallback(async () => {
    if (!localStorage.getItem("aurum_token")) { setUser(false); setEnt(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadEnt();
    } catch {
      localStorage.removeItem("aurum_token");
      setUser(false);
      setEnt(null);
    }
  }, [loadEnt]);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("aurum_token", data.token);
    setUser(data.user);
    await loadEnt();
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("aurum_token", data.token);
    setUser(data.user);
    await loadEnt();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("aurum_token");
    setUser(false);
    setEnt(null);
  };

  const refreshUser = load;
  const plan = ent?.plan || "FREE";
  const can = (feature) => Boolean(ent?.entitlements?.[feature]);

  return (
    <AuthContext.Provider value={{ user, ent, plan, can, login, register, logout, refreshUser, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
